// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"6fbee717","213":"850fd19b","253":"e35e0cf1","281":"17348d5b","287":"73c67021","313":"c52186b5","356":"c000407a","376":"3fe9e1c0","399":"b27db7a7","490":"a9fad177","518":"3239ccc5","879":"f88ce189","959":"f13c5304"}[chunkId] + ".chunk.js";
};